/*
 *
 * File JS per animazione
 *
 */
// import gsap from "gsap";

import ScrollMagic from "scrollmagic";
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./animate-in.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const animateIn = () => {
    let controllerAnimateIn = new ScrollMagic.Controller();
    let fade = document.querySelectorAll(".fade");
    ScrollTrigger.config({ ignoreMobileResize: true });

    if (!fade) {
        return;
    } else {
        fade.forEach((el) => {
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: "onEnter",
                reverse: false,
                offset: 80,
            })
                .setClassToggle(el, "animate")
                .addTo(controllerAnimateIn);
        });
    }

    const allTBottom = gsap.utils.toArray(".t-bottom");
    allTBottom.forEach((tBottom) => {
        gsap.to(tBottom, {
            yPercent: 8,
            ease: "none",
            scrollTrigger: {
                trigger: tBottom,
                scrub: 1,
            },
        });
    });

    const allTTop = gsap.utils.toArray(".t-top");
    allTTop.forEach((tTop) => {
        gsap.to(tTop, {
            yPercent: -8,
            ease: "none",
            scrollTrigger: {
                trigger: tTop,
                scrub: 1,
            },
        });
    });
};

export default animateIn;

//--------------------------------------------------------------------//
